import React from 'react';
import './ApexTop.css';
import previewImage from './assets/apex no recoil script preview.png';
import { FaShoppingCart, FaDiscord } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ApexTop = () => {
  const { t } = useTranslation();
  return (
    <div className="apex-top-component">
      <div className="apex-top-left">
        <h1>
          The safest Apex<br /> 
          script on the <br /> 
          market.
        </h1>
        <p>
          Tired of getting beamed? No worries we got your back!<br />
          <span style={{ color: "#fd314a" }}>The best hardware Apex script out there</span> that gives you an advantage over other players while beeing completely undetectable!
        </p>
        <div className="apex-top-buttons">
          <button
            className="apex-top-button buy-now"
            onClick={() => window.location.href = "#pricing"}
          >
            <FaShoppingCart />
            <span>{t('buy_now')}</span>
          </button>
          <button
            className="apex-top-button reviews"
            onClick={() => window.open("https://discord.com/invite/zEeq3jTzAR", "_blank")}
          >
            <FaDiscord />
            <span>{t('join_discord')}</span>
          </button>
        </div>
      </div>
      <div className="apex-top-right">
        <img src={previewImage} alt="EAGLE SCRIPT Apex Legends No Recoil Script Interface - Customizable Settings" loading="lazy" />
      </div>
    </div>
  );
};

export default ApexTop;